import { render, staticRenderFns } from "./Staff.vue?vue&type=template&id=254c051a"
import script from "./Staff.vue?vue&type=script&lang=ts"
export * from "./Staff.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports